// donationSaga.js

import { all, fork, put, call, takeLatest } from 'redux-saga/effects';
import { donationAction } from './donationSlice';
import * as donationApiLib from '../lib/donationApi';
import * as storageApiLib from '../lib/storageApi';

function* list({ payload }) {
  try {
    const donationList = yield call(donationApiLib.listDonation, payload);
    yield put(donationAction.listSuccess(donationList));
  } catch (error) {
    yield put(donationAction.listFailure(error.message));
  }
}

function* donationOfDonorlist({ payload }) {
  try {
    const donorList = yield call(donationApiLib.listDonationOfDonor, payload);
    yield put(donationAction.donationOfDonorSearchListSuccess(donorList));
  } catch (error) {
    yield put(donationAction.donationOfDonorListFailure(error.message));
  }
}

function* detail({ payload }) {
  try {
    const donationInfo = yield call(donationApiLib.detailDonation, payload);

    yield put(donationAction.detailSuccess({ donationInfo }));
  } catch (error) {
    yield put(donationAction.detailFailure({ error }));
  }
}

function* add({ payload }) {
  try {
    const placeId = payload.placeId;
    const donationFileList = payload.donationFileList;
    const formValue = payload.formValue;
    const handleUploadProgress = payload.handleUploadProgress;

    const resultDonationFileList = yield call(storageApiLib.upload, {
      fileList: donationFileList,
      placeId,
      handleUploadProgress,
    });

    yield call(donationApiLib.addDonation, {
      ...formValue,
      placeId,
      donationFileList: resultDonationFileList,
    });

    yield put(donationAction.addSuccess());
  } catch (error) {
    yield put(donationAction.addFailure({ error }));
  }
}

function* update({ payload }) {
  try {
    const formValue = payload.formValue;
    const placeId = payload.placeId;
    const donationFileList = payload.donationFileList;
    const addDonationFileList = payload.addDonationFileList;
    const removeDonationFileList = payload.removeDonationFileList;
    const handleUploadProgress = payload.handleUploadProgress;

    const resultDonationFileList = yield call(storageApiLib.uploadAndRemove, {
      addFileList: addDonationFileList,
      removeFileList: removeDonationFileList,
      fileList: donationFileList,
      placeId: placeId,
      handleUploadProgress,
    });

    // donationFileList를 updateInfo 안으로 포함시킴
    const updatedFormValue = {
      donationId: formValue.donationId,
      updateInfo: {
        ...formValue.updateInfo,
        donationFileList: resultDonationFileList,
      },
    };

    // 서버 호출
    yield call(donationApiLib.updateDonation, updatedFormValue);

    yield put(donationAction.updateSuccess());
  } catch (error) {
    yield put(donationAction.updateFailure({ error }));
  }
}

function* remove({ payload }) {
  try {
    let callList = [];
    let donationIdList = [];
    let removeFilePathList = [];

    for (const donationInfo of payload.donationIdList) {
      donationIdList.push(donationInfo.donationId);
      const fileListInfo = donationInfo.donationFileList;

      for (const file of fileListInfo) {
        removeFilePathList.push(file.filePath);
        if (file.thumbFilePath) {
          removeFilePathList.push(file.thumbFilePath);
        }
      }
    }

    yield call(storageApiLib.remove, { filePathList: removeFilePathList });
    yield all([...callList]);
    yield call(donationApiLib.removeDonation, { donationIdList: donationIdList });

    yield put(donationAction.removeSuccess());
  } catch (error) {
    yield put(donationAction.removeFailure({ error }));
  }
}

export function* watchList() {
  yield takeLatest(donationAction.list.type, list);
}

export function* watchDonationOfDonorList() {
  yield takeLatest(donationAction.donationOfDonorList.type, donationOfDonorlist);
}

export function* watchDetail() {
  yield takeLatest(donationAction.detail, detail);
}

export function* watchUpdate() {
  yield takeLatest(donationAction.update, update);
}

export function* watchAdd() {
  yield takeLatest(donationAction.add, add);
}

export function* watchRemove() {
  yield takeLatest(donationAction.remove, remove);
}

function* rootSaga() {
  yield all([
    fork(watchList),
    fork(watchAdd),
    fork(watchDetail),
    fork(watchUpdate),
    fork(watchDonationOfDonorList),
    fork(watchRemove),
  ]);
}

export default rootSaga;
